import { render, staticRenderFns } from "./DetailContentLayout.vue?vue&type=template&id=37243f13&scoped=true"
import script from "./DetailContentLayout.vue?vue&type=script&lang=js"
export * from "./DetailContentLayout.vue?vue&type=script&lang=js"
import style0 from "./DetailContentLayout.vue?vue&type=style&index=0&id=37243f13&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37243f13",
  null
  
)

export default component.exports